<template>
    <div class="pc-wrap">
        <CompHeader />
        <el-container class="main">
            <el-aside width="240">
                <CompMenu class="menu-list" />
            </el-aside>
            <el-main>
                <router-view />
            </el-main>
        </el-container>
        <CompFooter ref="Footer"/>
        <CompFloating :show="show" :class="{'footer-box': footerStyle}"/>
    </div>
</template>

<script>
import { mapState } from "vuex";

import CompHeader from './common/header'
import CompMenu from './common/menu'
import CompFooter from './common/footer'
import CompFloating from './common/floating'
export default {
    components: {
        CompHeader,
        CompMenu,
        CompFooter,
        CompFloating
    },
    computed: {
        ...mapState({
            userId: (state) => state.user.userId,
        }),
    },
    data() {
        return {
            show: false,
            footerStyle: false
        }
    },
    async mounted() {
        await this.$nextTick()
        document.addEventListener('scroll', this.styleFun)

        if (this.userId && this.userId !== this.sensors.store.getDistinctId()) {
            this.sensors.login(this.userId);
        }
    },
    methods: {
        styleFun(e) {
            let top = e.target.scrollingElement.scrollTop
            if (top > 200) {
                this.show = true
            } else {
                this.show = false
            }

            if (this.$refs.Footer) {
                let footerOffsetTop = this.$refs.Footer.$el.offsetTop
                let height = e.target.scrollingElement.clientHeight
                if (top + height > footerOffsetTop) {
                    this.footerStyle = true
                } else {
                    this.footerStyle = false
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.pc-wrap {
    min-width: 1080px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    .main {
        flex: 1;
        width: 1080px;
        margin: 40px auto;
        .menu-list {
            margin-right: 40px;
        }
        .el-main {
            padding: 0;
        }
    }
    .footer-box {
        bottom: 216px;
        position: absolute;
    }
}
</style>